// Event-Queue, falls shopEvent/shopEcom noch nicht verfügbar
const eventQueue = [];

// Hilfsfunktion: sende Event oder speichere in Queue
const safeCall = (fn, ...args) => {
  if (typeof fn === "function") {
    fn(...args);
    console.log("Tracking event sent:", args[0], args[1] || {});
  } else {
    console.warn("Tracking function not available, saving to queue:", args[0]);
    eventQueue.push({ fnName: (fn && fn.name) ? fn.name : "unknown", args });
    localStorage.setItem("trackingQueue", JSON.stringify(eventQueue));
  }
};

// Prüft die Queue bei Laden nach und feuert die Events
export const flushEventQueue = () => {
  const storedQueue = JSON.parse(localStorage.getItem("trackingQueue") || "[]");
  storedQueue.forEach(ev => {
    if (ev.fnName === "shopEvent" && typeof window.shopEvent === "function") {
      window.shopEvent(...ev.args);
    } else if (ev.fnName === "shopEcom" && typeof window.shopEcom === "function") {
      window.shopEcom(...ev.args);
    }
  });
  // Queue leeren
  localStorage.removeItem("trackingQueue");
  eventQueue.length = 0;
};

// ----------------------
// Universelle Tracking-Funktion
// ----------------------
export const trackEvent = (type, name, payload = {}) => {
  if(localStorage.getItem("cookieConsentAnalytic") === "true") {
    console.log("CONSENT GIVEN")
    if (type === "event") {
      safeCall(window.shopEvent, name, payload);
    } else if (type === "ecom") {
      safeCall(window.shopEcom, name, payload);
    } else {
      console.warn("Unknown tracking type:", type);
    }
  }
};

// ----------------------
// Convenience Wrappers
// ----------------------
export const trackSignUp = (method = "email") =>
  trackEvent("event", "sign_up", { method });

export const trackCategoryView = (slug, categoryName) =>
  trackEvent("event", "view_item_list", {
    ecommerce: { item_list_id: slug, item_list_name: categoryName },
    page: { type: "category" }
  });

export const trackAddToCart = (itemId, itemName) =>
  trackEvent("ecom", "add_to_cart", {
    items: [{ item_id: itemId, item_name: itemName }]
  });

export const trackRemoveFromCart = (itemId, itemName) =>
  trackEvent("ecom", "remove_from_cart", {
    items: [{ item_id: itemId, item_name: itemName }]
  });

export const trackPurchase = (orderId, items) =>
  trackEvent("ecom", "purchase", {
    transaction_id: orderId,
    items: items.map(i => ({ item_id: i.id, item_name: i.name }))
  });

export const trackSearch = (searchTerm) =>
  trackEvent("event", "search", { search_term: searchTerm });

export const trackSearchResults = (searchTerm, resultsCount) =>
  trackEvent("event", "view_search_results", {
    search_term: searchTerm,
    results_count: resultsCount
  });

export const trackAddToWishlist = (itemId, itemName) =>
  trackEvent("ecom", "add_to_wishlist", {
    items: [{ item_id: itemId, item_name: itemName }]
  });


// WEBPACK FOOTER //
// ./src/components/tracking/Tracking.js